module.exports = __webpack_public_path__ + "img/D202011_1.41fb0823.jpg";